<template>
  <SeoLink :to="{ name: 'home' }" :class="position === 'left' ? 'homeIcon' : 'homeIconRight'">
    <img
      src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220511/143372aed4285cba97f6154c4e708f74.svg"
      alt=""
    />
  </SeoLink>
</template>
<script>
import SeoLink from "@/components/SeoLink.vue";
export default {
  components: { SeoLink },
  props: {
    position: {
      type: String,
      default: 'left'
    }
  }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px * 2 / 75 + rem;
}
.homeIcon {
  top: rem(15);
  left: rem(15);
  position: absolute;
  z-index: 99;
  cursor: pointer;
}
.homeIconRight{
  position: absolute;
  top: rem(15);
  right: rem(15);
  z-index: 99;
  cursor: pointer;
}
.homeIcon img,
.homeIconRight img {
  width: rem(27);
  height: rem(27);
}
</style>



// WEBPACK FOOTER //
// src/components/homeIcon.vue